import { escapeHtml } from "./escapeHtml";
import { AcroNode } from "./types";

export function renderLabel(node: AcroNode): string {
  const title = node.title ? `<div class="text-sm text-gray-700">${escapeHtml(node.title)}</div>` : "";
  const desc = node.description ? `<div class="text-xs text-gray-500">${escapeHtml(String(node.description))}</div>` : "";
  return `<div class="py-2">${title}${desc}</div>`;
}
